export function ticksToDate(ticks: number): Date | undefined {
    const ticksInMillisecond = 10000;
    const originDateTicks = 621355968000000000; // Ticks at the Unix epoch: 1970-01-01T00:00:00Z
    const millisecondsSinceOrigin = (ticks - originDateTicks) / ticksInMillisecond;
    try {
        const retVal = new Date(millisecondsSinceOrigin);
        if (!retVal || retVal.toString() === "Invalid Date") {
            return undefined;
        }
        return retVal;
    } catch {
        return undefined
    }
}

export const formatTimeS = (s: number): string => {
    const totalSeconds = Math.floor(s);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};